const abAnalytics = require('./ab-analytics');
const abClient = require('./ab-client');
const abPlatform = require('./ab-platform');
const abVariantCalculator = require('./ab-variant-calculator');

window.OT = window.OT || {};
window.OT.Common = window.OT.Common || {};

const client = abClient(
  abPlatform(window.$ || window.jQuery),
  abVariantCalculator(window.$ || window.jQuery),
  abAnalytics(window.analytics),
  window.OT.Common.Cookies
);

window.OT.Common.abClient = client;

if (window.OT.Events) {
  window.OT.Events.fire('abClient:ready');
}



// WEBPACK FOOTER //
// ./src/ab-bundle.js